<template>
  <div class="home-block">
    <home-block-title
      title="专题栏目"
      linkText="更多"
      :link="{
        path: '/commonMore',
        query: {
          commonMoreName: '专题栏目',
          showType: 'card',
          activeMenu: '专题栏目'
        }
      }"
    />

    <div class="list special-list">
      <div class="item" v-for="(item, index) in list" :key="index">
        <div class="img-wrap" @click="showInfo(item)">
          <img :src="item.readImageUrl" alt="" />
        </div>

        <div class="title">
          <div class="left" @click="showInfo(item)">
            <div class="text">{{ item.readName }}</div>
          </div>
          <div class="right">
            {{ formatDate(item.infoTime, "Y-M-D") }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import homeBlockTitle from "./home-block-title.vue"
  import { getSpecial } from "@/api/home.js"
  export default {
    components: { homeBlockTitle },
    data() {
      return {
        list: []
      }
    },
    created() {},
    mounted() {
      this.load()
    },
    methods: {
      load() {
        this.request()
      },
      request() {
        getSpecial({ pageSize: 2 }).then((res) => {
          console.log("🚀 ~ getSpecial ~ res:", res)
          let list = res.data.rows || []
          list = list.slice(0, 2)
          this.list = list
        })
      },
      formatDate(date, format) {
        if (!date) {
          return ""
        }
        var d = new Date(date)
        var map = {
          Y: d.getFullYear(),
          M: d.getMonth() + 1,
          D: d.getDate(),
          hh: d.getHours(),
          mm: d.getMinutes(),
          ss: d.getSeconds()
        }

        // 从左边补齐二位
        for (var f2 in map) {
          map[f2] = map[f2].toString().padStart(2, "0")
        }

        for (var f1 in map) {
          format = format.replace(f1, map[f1])
        }
        return format
      },

      showInfo(item) {
        const apiUrl = `/web/portal/special/get/one?id=${item.id}`

        this.$router.push({
          path: "/commonShow",
          query: {
            f: 1,

            // 数据源
            apiUrl: apiUrl,

            // 面包屑 第二级菜单
            localActiveMenu: "专题栏目"
          }
        })
      }
    }
  }
</script>

<style scoped lang="scss">
  .special-list {
    padding: 20px 20px;
    gap: 20px;
    grid-template-rows: 1fr 1fr;
    height: 560px;
    .item {
      display: grid;
      grid-template-columns: 1fr;
      grid-template-rows: 1fr 24px;
    }
    .img-wrap {
      overflow: hidden;
      img {
        width: 100%;
        height: 100%;
        cursor: pointer;
      }
    }
    .title {
      height: 24px;
      line-height: 24px;

      display: grid;
      grid-template-columns: 1fr 96px;
    }
  }
</style>
